import CreateNewPage from './Pages/CreateNewPage';
import GlobalElements from './Pages/GlobalElements';
import $ from 'jquery';

/**
 * @todo Boris & Davor - this file should be inside OP Builder - with all files inside /OP3Builder/ folder
 */
export default class Builder {
    constructor() {
        this.secondaryMenu = window.OP3General.createCollapsibleMenu('.opb-template-category-menu');
        this.createPageSlider = null;
        this.movingImage = null;

        window.OP3General.pages.createNewPage = new CreateNewPage();
        window.OP3General.globalElements.admin = new GlobalElements();

        let _this = this;
        $(() => {
            _this.createPageSlider = window.OP3General.createWallopAjaxSlider('.opb_create-new-page-slider', $);

            _this.combineMenuAndSlider();
            _this.disableFormsFromSubmittingTwice();
        });

    }

    /**
     * Don't let some forms be submitted by clicking multiple times
     * 
     * @return {Void}
     */
    disableFormsFromSubmittingTwice() {
        $('body').on('submit', '.ops-form-single-submit', function() {
            let $form = $(this);
            let $button = $form.find('input[type=submit], button[type=submit]');
            let submitText = $button.data('submit-text');

            // Check if already submitting
            if ($form.data('submitting')) {
                return false;
            }

            // Fade the button slightly and change the text
            $button.fadeTo(100, .5).css('cursor', 'not-allowed');
            if (submitText) $button.text(submitText);

            // Mark the form as submitting
            $form.data('submitting', true);
        });
    }

    /**
     * Changing menu and slides together when moved over menu item or slider swipe
     *
     * @return {Void}
     */
    combineMenuAndSlider() {
        let _this = this;

        this.movingImage = window.OP3General.createMovingImage('.ops-moving-image');

        this.secondaryMenu.on('movingBorderMenu:change', ($menuLI) => {
            _this.createPageSlider.changeSlide($menuLI.index());
            _this.movingImage.destroy();
            _this.movingImage = window.OP3General.createMovingImage('.ops-moving-image');
        });

        this.secondaryMenu.on('collapsibleMenu:change', ($menuLI) => {
            _this.createPageSlider.changeSlide($menuLI.index());
            _this.movingImage.destroy();
            _this.movingImage = window.OP3General.createMovingImage('.ops-moving-image');
        });

        this.secondaryMenu.triggerInitialEvents();
        this.createPageSlider.on('wallopSlider:change', (event) => {
            _this.secondaryMenu.changeMenu(event.detail.currentItemIndex);
        });
    }
}
